'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dInput$002dType from "./mealorama.components.-Mui-Components$-Input-Type.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MuiComponents$InputType$$anon$2() {
  this.lm = null;
  $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dInput$002dType.$ct_Lmealorama_components_MuiComponents$InputType__T__(this, "number");
}
export { $c_Lmealorama_components_MuiComponents$InputType$$anon$2 as $c_Lmealorama_components_MuiComponents$InputType$$anon$2 };
$p = $c_Lmealorama_components_MuiComponents$InputType$$anon$2.prototype = new $j_mealorama$002ecomponents$002e$002dMui$002dComponents$0024$002dInput$002dType.$h_Lmealorama_components_MuiComponents$InputType();
$p.constructor = $c_Lmealorama_components_MuiComponents$InputType$$anon$2;
/** @constructor */
function $h_Lmealorama_components_MuiComponents$InputType$$anon$2() {
}
export { $h_Lmealorama_components_MuiComponents$InputType$$anon$2 as $h_Lmealorama_components_MuiComponents$InputType$$anon$2 };
$h_Lmealorama_components_MuiComponents$InputType$$anon$2.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return "Number";
});
$p.m = (function() {
  return "Number";
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("Number");
});
var $d_Lmealorama_components_MuiComponents$InputType$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MuiComponents$InputType$$anon$2, "mealorama.components.MuiComponents$InputType$$anon$2", ({
  Hv: 1,
  cc: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_components_MuiComponents$InputType$$anon$2 as $d_Lmealorama_components_MuiComponents$InputType$$anon$2 };
//# sourceMappingURL=mealorama.components.-Mui-Components$-Input-Type$$anon$2.js.map
